import { useTranslation } from "react-i18next";

export default function Form(props) {
  const { t, i18n } = useTranslation();

  return (
    <div className={props.registered ? "hidden" : ""}>
      <form className="text-gray-700 font-medium">
        <label>
          {t("description.language")}
          <button
            onClick={() => i18n.changeLanguage("en")}
            className="h-8 hover:underline"
          >
            English
          </button>
          <span className="font-light">&nbsp;/&nbsp;</span>
          <button
            onClick={() => i18n.changeLanguage("zh")}
            className="h-8 hover:underline"
          >
            中文
          </button>
        </label>
        <br />
        <label htmlFor="name">
          {t("description.formName")}
          <input
            type="text"
            name="name"
            id="name"
            placeholder={t("description.formNamePlaceholder")}
            className="border-0 border-b-2 border-green-300 h-8 placeholder-gray-300 focus:ring-0 focus:border-green-500"
            onChange={(e) => props.setName(e.target.value)}
          />
          <label>,</label>
        </label>
        <br />
        <label htmlFor="birthday">
          {t("description.formBirth")}
          <input
            type="date"
            name="birthday"
            id="birthday"
            className="border-0 border-b-2 border-green-300 h-8 focus:ring-0 focus:border-green-500"
            onChange={(e) => props.setBirthday(e.target.value)}
          />
          <label>,</label>
        </label>{" "}
        <br />
        <label htmlFor="expected">
          {t("description.formAge")}
          <input
            type="number"
            name="expected"
            id="expected"
            placeholder="70"
            className="border-0 border-b-2 border-green-300 h-8 placeholder-gray-300 focus:ring-0 focus:border-green-500"
            onChange={(e) => props.setExpected(e.target.value)}
          />
          <label>.</label>
        </label>
        <div className="grid">
          <button
            className="font-bold text-xl text-white mt-6 bg-green-300 rounded-sm"
            type="submit"
            onClick={() => props.setRegistered(true)}
          >
            {t("description.formSubmit")}
          </button>
        </div>
      </form>
    </div>
  );
}
